/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.services {
    import MapConfiguration = Wars.Domain.Model.Gis.MapConfiguration;

    export class MapConfigurationService extends services.DataService<Wars.Domain.Model.Gis.MapConfiguration> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);

        }

        public getMapConfigurations(): angular.
            IPromise<Wars.Domain.Model.Gis.MapConfiguration[]> {
            const query = this.breezeModule.EntityQuery
                .from("MapConfigurations")
                .expand('mapFunctions, gisActionWorkflowConfigurations, queryGridConfigurations')
                .orderBy("name");

            return this.executeQuery(query);
        }

        public getLayerConfigurations(mapConfigurationId: string): angular.IPromise<Wars.Domain.Model.Gis.Layer[]> {
            const query = this.breezeModule.EntityQuery
                .from("Layers")
                .where('mapConfiguration_id', '==', mapConfigurationId)
                .orderBy("name");

            return (<angular.IPromise<Wars.Domain.Model.Gis.Layer[]>>((this.executeQuery(query)) as any));
        }

        public getMapConfiguration(id: string): angular.IPromise<Wars.Domain.Model.Gis.MapConfiguration> {
            const d = this.$q.defer();

            const query = this.breezeModule.EntityQuery
                .from("MapConfigurations")
                .where('id', '==', id)
                .expand("layers.esriMapServiceMetadata.layers.fields," +
                    "javascriptTransformers," +
                    "gisActionWorkflowConfigurations.gisActionBlocks," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.setPropertyConfiguration," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.gisActionValidationConfiguration," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.bufferConfiguration," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.inputCollection.gisInputOutputs.relatedGisInputOutput," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.outputCollection.gisInputOutputs.relatedGisInputOutput," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.drawFeatureConfiguration.drawStyle," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.trimConfiguration.lineTrimAttributes," +
                    "gisActionWorkflowConfigurations.gisActionBlocks.gisActionBlockEsriQueryConfiguration, " +
                    "gisActionWorkflowConfigurations.gisActionBlocks.filterFeatureCollectionConfiguration.filterAttributes, " +
                    "gisActionWorkflowConfigurations.gisActionBlocks.addFeaturesConfiguration.featureAttributeToPropertyMaps, " +
                    "queryGridConfigurations.queryGridQueries.gisFieldMappings.includedQueryField, " +
                    "queryGridConfigurations.includedQueryFields, " +
                    "queryGridConfigurations.drawStyle, " +
                    "esriQueryConfigurations.wherePredicates, " +
                    "esriQueryConfigurations.geometryFilter, " +
                    "gisDatastoreQueryConfigurations.wherePredicates, " +
                    "gisDatastoreQueryConfigurations.geometryFilter, " +
                    "legendConfigurations.legendLayers," +
                    "mapFunctions.drawFeatureConfiguration.drawStyle," +
                    "mapFunctions.zoomToQueryConfiguration.placeHolderForInput ");

            this.executeQuery(query).then(r => {
                d.resolve(r[0]);
            });

            return d.promise;
        }

        public createMapConfiguration(): Wars.Domain.Model.Gis.MapConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.MapConfiguration>("MapConfiguration");
        }


        public createGisWherePedicate(): Wars.Domain.Model.Gis.GisWherePredicate {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisWherePredicate>("GisWherePredicate");
        }

        public createLayer(): Wars.Domain.Model.Gis.Layer {
            return this.createNewEntity<Wars.Domain.Model.Gis.Layer>("Layer");
        }

        public createMapFunctionConfiguration(): Wars.Domain.Model.Gis.MapFunctionConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.MapFunctionConfiguration>("MapFunctionConfiguration");
        }

        public createEsriQueryConfiguration(): Wars.Domain.Model.Gis.EsriQueryConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.EsriQueryConfiguration>("EsriQueryConfiguration");
        }

        public createEsriPlaceHolderValue(): Wars.Domain.Model.Gis.GisWherePlaceHolderValue{
            return this.createNewEntity<Wars.Domain.Model.Gis.GisWherePlaceHolderValue>("GisWherePlaceHolderValue");
        }

        public createGeometryFilter(): Wars.Domain.Model.Gis.GeometryFilter {
            return this.createNewEntity<Wars.Domain.Model.Gis.GeometryFilter>("GeometryFilter");
        }

        public createQueryGridConfiguration(): Wars.Domain.Model.Gis.QueryGridConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.QueryGridConfiguration>("QueryGridConfiguration");
        }

        public createIncludedQueryField(): Wars.Domain.Model.Gis.IncludedQueryField {
            return this.createNewEntity<Wars.Domain.Model.Gis.IncludedQueryField>("IncludedQueryField");
        }

        public createQueryGridQuery(): Wars.Domain.Model.Gis.QueryGridQuery {
            return this.createNewEntity<Wars.Domain.Model.Gis.QueryGridQuery>("QueryGridQuery");
        }

        public createQueryGridFieldMapping(): Wars.Domain.Model.Gis.GisFieldMapping {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisFieldMapping>("GisFieldMapping");
        }

        public createGisActionBlock(): Wars.Domain.Model.Gis.GisActionBlock {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionBlock>("GisActionBlock");
        }

        public createFilterAttribute(): Wars.Domain.Model.Gis.FilterAttribute {
            return this.createNewEntity <Wars.Domain.Model.Gis.FilterAttribute>("FilterAttribute");
        }

        public createAddFeaturesConfiguration(): Wars.Domain.Model.Gis.AddFeaturesConfiguration{
            return this.createNewEntity<Wars.Domain.Model.Gis.AddFeaturesConfiguration>("AddFeaturesConfiguration");
        }

        public createDrawFeatureConfiguration(): Wars.Domain.Model.Gis.DrawFeatureConfiguration {
            let drawFeatureConfiguration = this.createNewEntity<Wars.Domain.Model.Gis.DrawFeatureConfiguration>("DrawFeatureConfiguration");

            drawFeatureConfiguration.drawStyle = this.createDrawStyle();
            drawFeatureConfiguration.drawingType = Wars.Domain.Model.Codes.Enums.GeometryType.LineString;
            drawFeatureConfiguration.clearDrawingAfterSelection = false;

            return drawFeatureConfiguration;
        }

        public createTrimConfiguration(): Wars.Domain.Model.Gis.TrimConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.TrimConfiguration>("TrimConfiguration");
        }

        public createGisActionCalculationConfiguration(): Wars.Domain.Model.Gis.GisActionCalculationConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionCalculationConfiguration>("GisActionCalculationConfiguration");
        }

        public createFilterFeatureCollectionConfiguration(): Wars.Domain.Model.Gis.FilterFeatureCollectionConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.FilterFeatureCollectionConfiguration>("FilterFeatureCollectionConfiguration");
        }

        public createValidationConfiguration(): Wars.Domain.Model.Gis.GisActionValidationConfiguration{
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionValidationConfiguration>("GisActionValidationConfiguration");
        }

        public creatSetPropertyConfiguration(): Wars.Domain.Model.Gis.SetPropertyConfiguration{
            return this.createNewEntity<Wars.Domain.Model.Gis.SetPropertyConfiguration>("SetPropertyConfiguration");
        }

        public createGisDatastoreQueryConfiguration(): Wars.Domain.Model.Gis.GisDatastoreQueryConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisDatastoreQueryConfiguration>("GisDatastoreQueryConfiguration");
        }

        public createGisActionWorkflowConfiguration(): Wars.Domain.Model.Gis.GisActionWorkflowConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionWorkflowConfiguration>("GisActionWorkflowConfiguration");
        }

        public createJavascriptTransformer(): Wars.Domain.Model.Gis.JavascriptTransformer {
            return this.createNewEntity<Wars.Domain.Model.Gis.JavascriptTransformer>("JavascriptTransformer");
        }

        public createGisInputOutput(): Wars.Domain.Model.Gis.GisInputOutput {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisInputOutput>("GisInputOutput");
        }

        public createGisInputOutputCollection(): Wars.Domain.Model.Gis.GisInputOutputCollection {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisInputOutputCollection>("GisInputOutputCollection");
        }

        public createGisActionBlockEsriQueryConfiguration(): Wars.Domain.Model.Gis.GisActionBlockEsriQueryConfiguration {
            return this.createNewEntity<Wars.Domain.Model.Gis.GisActionBlockEsriQueryConfiguration>("GisActionBlockEsriQueryConfiguration");
        }

        public createLineTrimAttribute(): Wars.Domain.Model.Gis.LineTrimAttribute {
            return this.createNewEntity<Wars.Domain.Model.Gis.LineTrimAttribute>("LineTrimAttribute");
        }

        public createBufferConfiguration(): Wars.Domain.Model.Gis.BufferConfiguration{
            return this.createNewEntity<Wars.Domain.Model.Gis.BufferConfiguration>("BufferConfiguration");
        }

        public createFeatureAttributeToPropertyMap(): Wars.Domain.Model.Gis.FeatureAttributeToPropertyMap {
            return this.createNewEntity<Wars.Domain.Model.Gis.FeatureAttributeToPropertyMap>("FeatureAttributeToPropertyMap");
        }

        public createDrawStyle(): Wars.Domain.Model.Gis.DrawStyle {
            let drawStyle = this.createNewEntity<Wars.Domain.Model.Gis.DrawStyle>("DrawStyle");

            drawStyle.stroke = true;
            drawStyle.color = '#3388ff';
            drawStyle.weight = 3;
            drawStyle.opacity = 1;
            drawStyle.fill = true;
            drawStyle.fillColor = '#3388ff';
            drawStyle.fillOpacity = 0.2;

            return drawStyle;
        }

        public createZoomToQueryConfiguration(): Wars.Domain.Model.Gis.ZoomToQueryConfiguration {
            let returnObj = this.createNewEntity<Wars.Domain.Model.Gis.ZoomToQueryConfiguration>("ZoomToQueryConfiguration");

            returnObj.highlightZoomResults = false;

            return returnObj;
        }
    }
}

warsApp.registerService('MapConfigurationService', ['breeze', '$q', '$http']);